import { KatalComponent } from '../../shared/base';

/**
 * @component {kat-link} KatalLink Link to a different page
 * @example Amazon.com {"label": "Amazon", "href":"https://www.amazon.com", "variant":"link"}
 * @example LinkAsButton {"label": "Amazon", "href":"https://www.amazon.com", "variant":"button"}
 * @status Production
 */
class KatalLink extends KatalComponent {
  static get observedAttributes() {
    return ['label', 'href', 'target', 'variant', 'download'];
  }

  constructor() {
    super(KatalLink.observedAttributes);
  }

  connectedCallback() {
    super.connectedCallback();
    this.render();
  }

  /**
   * @classprop {string} label The text to display for the link
   */
  get label() {
    return this.getAttribute('label') || '';
  }

  set label(value) {
    this.setAttribute('label', value);
  }

  /**
   * @classprop {string} href The location to navigate to
   */
  get href() {
    return this.getAttribute('href') || '';
  }

  set href(value) {
    this.setAttribute('href', value);
  }

  /**
   * @classprop {enum} target Specifes how to open the link
   * @enum {value} _blank Opens in a new window
   */
  get target() {
    return this.getAttribute('target');
  }

  set target(value) {
    this.setAttribute('target', value);
  }

  /**
   * @classprop {enum} variant Sets the visual variant of the link
   * @enum {value} link Displays as a traditional link - Default
   * @enum {value} button Displays the link as a button link
   */
  get variant() {
    return this.getAttribute('variant') || 'link';
  }

  set variant(value) {
    this.setAttribute('variant', value);
  }

  /**
   * @classprop {string} download If the attribute has a value, it is used as the pre-filled file name
   * in the Save prompt (the user can still change the file name if they want).
   */
  get download() {
    return this.getAttribute('download');
  }

  set download(value) {
    this.setAttribute('download', value);
  }

  render() {
    const target = this.target ? `target="${this.target}"` : '';
    const download = this.download ? `download="${this.download}"` : '';

    this.innerHTML = `<a href="${this.href}" ${target} ${download}>${this.label}</a>`;
  }

  // Respond to attribute changes.
  attributeChangedCallback() {
    this.render();
  }
}

KatalComponent.register('kat-link', KatalLink);
